var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchoolBench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.25C22.4142 4.25 22.75 4.58579 22.75 5V22C22.75 22.4142 22.4142 22.75 22 22.75C21.5858 22.75 21.25 22.4142 21.25 22V18.75H16C15.8619 18.75 15.75 18.8619 15.75 19V22C15.75 22.4142 15.4142 22.75 15 22.75C14.5858 22.75 14.25 22.4142 14.25 22V17C14.25 16.0335 15.0335 15.25 16 15.25H19V5.25C19 4.69772 19.4477 4.25 20 4.25H22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.1L4.25 12.9V22C4.25 22.4142 3.91421 22.75 3.5 22.75C3.08579 22.75 2.75 22.4142 2.75 22V12.3L2.62861 12.2515C2.24895 12.0996 2 11.7319 2 11.323V8.47706C2 7.7696 2.71453 7.28584 3.37139 7.54858L11.3714 10.7486C11.751 10.9004 12 11.2682 12 11.6771V14.523C12 15.0047 11.6688 15.3827 11.25 15.4919V22C11.25 22.4142 10.9142 22.75 10.5 22.75C10.0858 22.75 9.75 22.4142 9.75 22V15.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolBench);
export default __webpack_public_path__ + "static/media/school-bench.0d1fa92096cf7cc45b4aa6a86d44f23b.svg";
export { ForwardRef as ReactComponent };